import React, { Component } from 'react';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { css, StyleSheet } from 'aphrodite';
import { CommonStyles } from '../styles/Styles'

function LeftArrow(props) {
  const { onClick } = props;
  return (
    <div className={css(CommonStyles.iconContainer)}>
      <div
        className={props.currentSlide === 0
          ?
          css([CommonStyles.relatedImageSelectionContent, CommonStyles.arrowIconsDisabledContainer])
          :
          css(CommonStyles.relatedImageSelectionContent)}
        onClick={onClick} >
        <ChevronLeftIcon
          className={props.currentSlide === 0
            ?
            css(CommonStyles.arrowIconsDisabled)
            :
            css(CommonStyles.arrowIcons)} />
      </div>
    </div>
  );
}

function RightArrow(props) {
  const { onClick } = props;
  return (
    <div className={css(CommonStyles.iconContainer)}>
      <div className={(props.slideCount - props.currentSlide) <= slidesToShow
        ?
        css([CommonStyles.relatedImageSelectionContent, CommonStyles.rightArrow, CommonStyles.arrowIconsDisabledContainer])
        :
        css([CommonStyles.relatedImageSelectionContent, CommonStyles.rightArrow])}
      onClick={onClick} >
        <ChevronRightIcon
          className={(props.slideCount - props.currentSlide) <= slidesToShow
            ?
            css(CommonStyles.arrowIconsDisabled)
            :
            css(CommonStyles.arrowIcons)} />
      </div>
    </div>
  );
}

let slidesToShow = 3
if( window.innerWidth < 1800 && window.innerWidth >= 1000) {
  slidesToShow = 3
} else if( window.innerWidth < 1000 && window.innerWidth >= 767) {
  slidesToShow = 2
} else if( window.innerWidth < 767) {
  slidesToShow = 1
}

export const relativesettings = {
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  autoplay: true,
  autoplaySpeed: 4000,
  cssEase: 'linear',
  slidesToScroll: 1,
  lazyLoad: 'progressive',
  nextArrow: <RightArrow />,
  prevArrow: <LeftArrow />,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1800,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
};


// WEBPACK FOOTER //
// ./src/components/SliderSettings.js